import MarkerEntry from 'media/views/marker-entry';
import MapInput from 'media/views/map-input';


module.exports = { MarkerEntry, MapInput }
